import { DissectedError, DissectedErrorGroups, LogType, exists, logError } from '../../..'
import { ApiResponse } from '../../../types/Response'
import { DissectParserProps } from '../types/DissectParserTypes'

export const parseApiResponseIsSuccess = async <TApiResponse extends ApiResponse = ApiResponse>({
    responseBody,
    responseStatusText,
    responseStatus,
    throwWhenNotSuccessful: throwOnIsSuccessIsFalse,
    caller,
    formId,
}: DissectParserProps<TApiResponse>): Promise<void> => {
    try {
        const apiResponse = (await responseBody) as TApiResponse

        const statusCode = exists(apiResponse.errorCode) ? +apiResponse.errorCode : responseStatus
        const statusMessage = apiResponse.message ?? responseStatusText

        if (!apiResponse.isSuccess) {
            // Log when isSuccess is false
            logError(`${apiResponse.message ?? 'apiResponse.isSuccess is false'}`, {
                logType: LogType.RESPONSE_MESSAGE,
                caller,
            })
            if (throwOnIsSuccessIsFalse || exists(formId)) {
                // Only throw when explicitly instructed to do so
                throw new DissectedError(statusMessage ?? 'apiResponse.isSuccess is false', {
                    statusCode,
                    statusMessage,
                    callerAction: caller,
                    errorGroup: DissectedErrorGroups.IS_SUCCESS_FALSE,
                    verboseMessage: 'isSuccess is false on apiResponse, and throwOnFalseIsSuccess is true',
                    apiResponse,
                })
            }
        }
    } catch (error) {
        if (error instanceof DissectedError) {
            throw error
        }
        logError('unexpected error', {
            logType: LogType.UNEXPECTED,
            caller: `${caller} - parseApiResponseIsSuccess`,
        })
    }
}
